import Filter from "components/Filter"
import Loading from "components/Loading"
import { SearchWrapper } from "./styled"
import { useState } from "react"
import TourItem from "components/TourItem"
import { useLocation } from 'react-router-dom'
import Pagination from '@mui/material/Pagination';
import TourList from "components/TourList"
import useParams from "hooks/useParams"
import { searchActions } from "redux/slice/searchSlice"
import { useDispatch, useSelector } from "react-redux"
import { searchSelector, tourSelector } from "redux/selector"
import { useEffect } from "react"
import { tourActions } from "redux/slice/tourSlice"
import { actionScrollToTop } from "utils"

const PER_PAGE = 10

const Search = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const queryPath = location.pathname
    const mySlug = queryPath.split("/");
    const slug = mySlug[mySlug.length - 1]
    const query = new URLSearchParams(location.search)
    const qPage = query.get("page")
    const querySearch = query.get("key_word")
    const qProvince = query.get("province")
    const qPerson = query.get("person")
    const qSort = query.get("sort")
    const [minPrice, setMinPrice] = useState(0)
    const [maxPrice, setMaxPrice] = useState(50000000)
    const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1)
    const [provinceSelected, setProvinceSelected] = useState(qProvince && !isNaN(parseInt(qProvince)) ? parseInt(qProvince) : "all")
    const [person, setPerson] = useState(qPerson && !isNaN(parseInt(qPerson)) ? qPerson : "all")
    const [sortPrice, setSortPrice] = useState(qSort ? qSort : "final_price ASC")
    const { setParams } = useParams()
    const searchState = useSelector(searchSelector)
    const tourState = useSelector(tourSelector)

    const handleSubmitSort = () => {
        setParams({ person: person === "" ? "all" : person })
        const payload = {
            query: querySearch,
            province: provinceSelected,
            min: minPrice,
            max: maxPrice,
            sort: sortPrice,
            page: currentPage,
            perPage: PER_PAGE,
            person: person === "all" ? "" : person
        }
        dispatch(searchActions.search(payload))
    }

    const handleChangePaginate = (event, pageNumber) => {
        setCurrentPage(pageNumber)
        setParams({ page: pageNumber })
    }

    const handleChangeProvince = (e) => {
        setParams({ province: e.target.value })
        setProvinceSelected(e.target.value)
    }

    const handleChangeSortPrice = (e) => {
        setParams({ sort: e.target.value })
        setSortPrice(e.target.value)
    }


    const handleChangePerson = (e) => {
        setPerson(e.target.value)
    }

    useEffect(() => {
        const payload = {
            query: querySearch,
            province: provinceSelected,
            min: minPrice,
            max: maxPrice,
            sort: sortPrice,
            page: currentPage,
            perPage: PER_PAGE,
            person: person === "all" ? "" : person
        }
        dispatch(searchActions.search(payload))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, dispatch, provinceSelected, slug, sortPrice])


    useEffect(() => {
        dispatch(tourActions.getTourRandom())
    }, [dispatch])


    useEffect(() => {
        actionScrollToTop()
    }, [])


    return (
        <SearchWrapper className="container-fluid">
            {
                searchState.isFetching &&
                <Loading />
            }
            <div className="grid wide py-20">
                {/* <h1 className="s-18 black bold bg-grey2 p-15 title_container">{searchState.toutTypeListAll.length > 0 && searchState.toutTypeListAll.filter(item => item.slug === slug)[0].name}</h1> */}
                <div className="filter p-15 mt-15 bg-grey2">
                    <Filter
                        minPrice={minPrice}
                        maxPrice={maxPrice}
                        setMinPrice={setMinPrice}
                        setMaxPrice={setMaxPrice}
                        handleChangeProvince={handleChangeProvince}
                        provinceInit={provinceSelected}
                        person={person}
                        handleChangePerson={handleChangePerson}
                        handleChangeSortPrice={handleChangeSortPrice}
                        sortPrice={sortPrice}
                        handleSubmitSort={handleSubmitSort}
                    />
                </div>
                <div className="tour_list mt-20">
                    {
                        searchState.searchList.length > 0 &&
                        <div className="row">
                            {
                                searchState.searchList.map((item, key) => (
                                    <div className="l-3" key={key}>
                                        <TourItem
                                            thumbnail={item.thumbnail}
                                            tourName={item.name}
                                            tourPrice={item.final_price}
                                            discount={item.discount}
                                            tourOldPrice={item.price}
                                            slug={item.slug}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                    }
                    {
                        searchState.searchList.length === 0 &&
                        <div className="empty_data flex-center">
                            <span className="text-red">Tour trống!</span>
                        </div>
                    }
                </div>
                {
                    searchState.totalPage > 1 &&
                    <div className="flex-center mt-50">
                        <Pagination color="primary" count={searchState.totalPage} variant="outlined" shape="rounded"
                            onChange={(event, pageNumber) => handleChangePaginate(event, pageNumber)}
                            page={currentPage}
                        />
                    </div>
                }
                {
                    tourState.randomList.length > 3 &&
                    <div className="other_tour mt-50">
                        <TourList data={tourState.randomList} title="Tour khác" />
                    </div>
                }
            </div>
        </SearchWrapper>
    )
}

export default Search